const login = {
  inputs: [
    {
      label: "Email",
      type: "text",
      name: "email",
      placeholder: "Enter email address",
    },
    {
      label: "Password",
      type: "password",
      name: "password",
      placeholder: "Enter password",
    },
  ],
};
export default login;
